<nav
    class="header-class sticky top-0 isolate z-[1000] w-full overflow-x-clip bg-white/80 text-neutral-800 shadow-sm backdrop-blur-md transition-all duration-300"
    role="navigation"
    aria-label="Main Navigation">
    <div class="mx-4 flex items-center justify-between py-2 md:mx-16">
        <div class="flex items-center gap-3 md:gap-16">
            <button class="p-2 lg:hidden" (click)="headerService.toggleMenu()">
                <i
                    class="pi text-2xl"
                    [ngClass]="
                        headerService.menuOpen() ? 'pi-times' : 'pi-bars'
                    "></i>
            </button>

            <a
                class="flex cursor-pointer items-center"
                (click)="navigateToHome()">
                <img
                    src="assets/logo/hairstyleclub-full-logo.png"
                    class="h-8 w-auto object-contain md:h-12"
                    alt="Hair Style Club" />
            </a>
        </div>

        <div class="relative hidden items-center gap-8 lg:flex">
            @for (link of leftLinks; track link.id) {
                <a
                    fontSpanish
                    class="nav-link hover:text-primary relative font-medium tracking-wide text-gray-600 transition-colors duration-200"
                    [routerLink]="link.route"
                    routerLinkActive="active-link"
                    [routerLinkActiveOptions]="{ exact: true }">
                    {{ link.title | transloco }}
                    <span class="underline-bar"></span>
                </a>
            }
        </div>

        <div class="flex items-center gap-2 sm:gap-3">
            <div class="hidden items-center gap-5 lg:flex">
                @for (link of rightLinks; track link.id) {
                    <a
                        fontSpanish
                        class="nav-link hover:text-primary relative mt-1 font-medium tracking-wide text-gray-600 transition-colors duration-200"
                        [routerLink]="link.route"
                        routerLinkActive="active-link"
                        [routerLinkActiveOptions]="{ exact: true }">
                        {{ link.title | transloco }}
                        <span class="underline-bar"></span>
                    </a>
                }
            </div>

            @let userDetails =
                headerAuthService.auth.select('userDetails') | async;
            @let profilePhoto =
                profileStateService.select('profilePhotoUrl') | async;

            @if (headerAuthService.auth.isLoggedIn()) {
                <div class="flex items-center gap-3 sm:gap-4">
                    <a
                        fontSpanish
                        class="hover:border-primary hover:text-primary hidden rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm sm:block"
                        [routerLink]="
                            headerAuthService.auth.getGroupType() === 'client'
                                ? ['/dashboard/home/client']
                                : ['/dashboard/home']
                        ">
                        {{ 'header.publicHeader.auth.dashboard' | transloco }}
                    </a>

                    <div
                        (click)="headerAuthService.toggleDropdown()"
                        class="cursor-pointer">
                        <user-login-status
                            [user]="
                                $safeNavigationMigration(
                                    userDetails?.user?.firstName
                                ) +
                                ' ' +
                                $safeNavigationMigration(
                                    userDetails?.user?.lastName
                                )
                            "
                            [verifiedAt]="
                                $safeNavigationMigration(
                                    userDetails?.user?.verifiedAt
                                )
                            "
                            [userRole]="
                                userDetails?.organizationType === 'client'
                                    ? ''
                                    : $safeNavigationMigration(
                                          userDetails?.role?.name
                                      ) || ''
                            "
                            [profilePhoto]="profilePhoto ?? ''">
                        </user-login-status>
                    </div>
                </div>
            } @else {
                <div class="hidden items-center gap-3 lg:flex">
                    <a
                        fontSpanish
                        routerLink="/login"
                        class="inline-flex items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-xs transition-colors hover:bg-gray-50 hover:text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700">
                        {{ 'header.publicHeader.auth.signIn' | transloco }}
                    </a>
                    <p-button
                        fontSpanish
                        rounded="true"
                        size="small"
                        severity="primary"
                        routerLink="/signup"
                        >{{
                            'header.publicHeader.auth.signUp' | transloco
                        }}</p-button
                    >
                </div>
            }

            <div class="flex items-center">
                <app-language-dropdown />
            </div>
        </div>
    </div>

    @if (headerService.menuOpen()) {
        <div
            class="fixed inset-0 z-[1010] bg-black/20 backdrop-blur-sm transition-opacity duration-300"
            (click)="headerService.closeMenu()"></div>
    }

    <div
        class="fixed top-0 left-0 z-[1020] h-screen w-72 bg-white shadow-2xl transition-transform duration-300 ease-in-out"
        [ngClass]="
            headerService.menuOpen() ? 'translate-x-0' : '-translate-x-full'
        "
        (click)="$event.stopPropagation()">
        <div
            class="flex items-center justify-between border-b border-gray-200 px-5 py-2.5">
            <a (click)="navigateToHome()" class="flex items-center">
                <img
                    src="assets/logo/hairstyleclub-full-logo.png"
                    class="h-8 w-auto object-contain"
                    alt="Hair Style Club" />
            </a>

            <button
                fontSpanish
                (click)="headerService.closeMenu()"
                class="z-50 flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md transition hover:bg-gray-100">
                <i class="pi pi-times text-xl"></i>
            </button>
        </div>

        <div class="h-[calc(100%-70px)] space-y-1 overflow-y-auto px-4 py-4">
            @for (link of headerRoutesData; track link.id) {
                <a
                    fontSpanish
                    class="hover:bg-primary-50 hover:text-primary-700 block rounded-lg px-4 py-3 text-base font-medium text-gray-700 transition-colors"
                    [routerLink]="link.route"
                    routerLinkActive="active-link"
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="headerService.closeMenu()">
                    {{ link.title | transloco }}
                </a>
            }

            <div class="mt-6 border-t border-gray-200 px-4 pt-6">
                <div class="mt-8 space-y-3">
                    @if (headerAuthService.auth.isLoggedIn()) {
                        <a
                            fontSpanish
                            class="bg-primary shadow-secondary flex items-center justify-center rounded-xl px-4 py-3 font-semibold text-white shadow-lg"
                            [routerLink]="
                                headerAuthService.auth.getGroupType() ===
                                'client'
                                    ? ['/dashboard/home/client']
                                    : ['/dashboard/home']
                            "
                            (click)="headerService.closeMenu()">
                            {{
                                'header.publicHeader.auth.goToDashboard'
                                    | transloco
                            }}
                        </a>
                    } @else {
                        <a
                            fontSpanish
                            class="block w-full rounded-xl border border-gray-200 px-4 py-3 text-center font-semibold text-gray-700"
                            routerLink="/login"
                            (click)="headerService.closeMenu()">
                            {{ 'header.publicHeader.auth.signIn' | transloco }}
                        </a>

                        <a
                            fontSpanish
                            class="bg-primary block w-full rounded-xl px-4 py-3 text-center font-semibold text-white"
                            routerLink="/signup"
                            (click)="headerService.closeMenu()">
                            {{
                                'header.publicHeader.auth.createAccount'
                                    | transloco
                            }}
                        </a>
                    }
                </div>
            </div>
        </div>
    </div>
</nav>
